import { LegalLayout } from "../components/LegalLayout";

export default function CookiePolicy() {
  return (
    <LegalLayout title="Cookie Policy" updated="Giugno 2026" testId="cookie-policy-page">
      <p>
        La presente Cookie Policy descrive l'utilizzo di cookie e tecnologie similari (pixel, local
        storage, identificatori) su questo sito, gestito da <strong>BEETOO AGENCY S.R.L.</strong> (Via
        dell'Industria 26/B – 34144 Trieste (TS), P.IVA IT01275560322, PEC: beetooagency@pec.it), in
        conformità al GDPR e al Provvedimento del Garante Privacy del 10 giugno 2021.
      </p>

      <h2>1. Cosa sono i cookie</h2>
      <p>
        I cookie sono piccoli file di testo che i siti visitati inviano al dispositivo dell'utente, dove
        vengono memorizzati per essere ritrasmessi agli stessi siti alla visita successiva. Tecnologie
        similari (come pixel di tracciamento e local storage) sono utilizzate per finalità analoghe.
      </p>

      <h2>2. Cookie e tecnologie utilizzate</h2>

      <h3>a) Cookie tecnici (sempre attivi – non richiedono consenso)</h3>
      <table>
        <thead>
          <tr>
            <th>Nome</th>
            <th>Finalità</th>
            <th>Durata</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>pv_consent (local storage)</td>
            <td>Memorizza la scelta espressa nel banner cookie</td>
            <td>Persistente fino a cancellazione</td>
          </tr>
          <tr>
            <td>pv_video_pos_*, pv_ms_* (local storage)</td>
            <td>Memorizza il punto di visualizzazione dei video per riprenderli dove interrotti</td>
            <td>Persistente fino a cancellazione</td>
          </tr>
          <tr>
            <td>pv_attribution (local storage)</td>
            <td>Memorizza la sorgente di provenienza della visita (parametri della campagna)</td>
            <td>Persistente fino a cancellazione</td>
          </tr>
        </tbody>
      </table>

      <h3>b) Cookie e pixel di marketing (attivi solo con il tuo consenso)</h3>
      <table>
        <thead>
          <tr>
            <th>Nome</th>
            <th>Fornitore</th>
            <th>Finalità</th>
            <th>Durata</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>_fbp</td>
            <td>Meta Platforms Ireland Ltd.</td>
            <td>Distinguere gli utenti e misurare l'efficacia delle campagne pubblicitarie</td>
            <td>90 giorni</td>
          </tr>
          <tr>
            <td>_fbc</td>
            <td>Meta Platforms Ireland Ltd.</td>
            <td>Memorizzare l'identificativo del click proveniente da un annuncio Meta</td>
            <td>90 giorni</td>
          </tr>
          <tr>
            <td>Meta Pixel + Conversions API</td>
            <td>Meta Platforms Ireland Ltd.</td>
            <td>
              Tracciamento di eventi (visualizzazione pagina, visualizzazione video, click sui pulsanti,
              invio modulo) per misurazione delle conversioni, creazione di pubblici personalizzati e
              retargeting
            </td>
            <td>Secondo policy Meta</td>
          </tr>
        </tbody>
      </table>
      <p>
        Con il tuo consenso, i dati raccolti tramite queste tecnologie possono essere utilizzati per
        attività di <strong>retargeting pubblicitario</strong> sulle piattaforme{" "}
        <strong>Meta (Facebook/Instagram), TikTok, YouTube e Google</strong> e per la creazione di
        pubblici personalizzati.
      </p>
      <p>
        Terze parti coinvolte: cookie tecnici di terze parti possono essere impostati dal player video{" "}
        <strong>Vimeo Inc.</strong> per l'erogazione dei contenuti video (
        <a href="https://vimeo.com/privacy" target="_blank" rel="noreferrer">
          privacy policy Vimeo
        </a>
        ).
      </p>

      <h2>3. Gestione del consenso</h2>
      <p>
        Al primo accesso al sito viene mostrato un banner che consente di:
      </p>
      <ul>
        <li>
          <strong>Accettare tutti</strong> i cookie (tecnici + marketing);
        </li>
        <li>
          <strong>Proseguire con i soli cookie necessari</strong> (i cookie di marketing e il Meta Pixel
          non verranno attivati).
        </li>
      </ul>
      <p>
        La scelta può essere modificata in qualsiasi momento cliccando su{" "}
        <strong>"Gestisci consenso cookie"</strong> nel footer del sito. È inoltre possibile eliminare i
        cookie tramite le impostazioni del proprio browser.
      </p>

      <h2>4. Come disabilitare i cookie dal browser</h2>
      <ul>
        <li>Chrome: Impostazioni → Privacy e sicurezza → Cookie</li>
        <li>Firefox: Impostazioni → Privacy e sicurezza</li>
        <li>Safari: Preferenze → Privacy</li>
        <li>Edge: Impostazioni → Cookie e autorizzazioni sito</li>
      </ul>
      <p>
        Per maggiori informazioni sul trattamento dei dati personali si rinvia alla{" "}
        <a href="/privacy-policy">Privacy Policy</a>.
      </p>
    </LegalLayout>
  );
}
